
import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../../Layout/MainLayouts";

import { ReactComponent as CheckSquareFill } from "bootstrap-icons/icons/check-square-fill.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as XSquareFill } from "bootstrap-icons/icons/x-square-fill.svg";
import { ReactComponent as CashStack } from "bootstrap-icons/icons/cash-stack.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import Spinner from "../../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../../components/utils/CustomStyles";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../../api/AxiosApiCall";
import { AuthContext } from "../../../AuthProvider/AuthProvider";
// import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";


const ExpensesList = () => {
  const [expense, setExpenses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const [perPage, setPerPage] = useState(20);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [selectedData, setSelectedData] = useState([]);

  const { permissions } = useContext(AuthContext);
  // console.log("this is all the perm", permissions);

  const navigate = useNavigate();

  //axios api encryption call
  const axios = AxiosApiCall();

  const fetchAllExpenses = async () => {
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }
      const response = await axios.get(ApiServices.getExpenseOpePending, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          page: page,
          per_page: perPage,
        },
        withCredentials: true,
      });

      const { status, message, data } = response.data;
      // console.log("this is all expenses list", data);

      if (status === 200) {
        setExpenses(data.expenses);
        setTotal(data.total);
        setPerPage(data.per_page);
        setPage(data.current_page);
        toast.success(message, { toastId: "product-fetch-success" });
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllExpenses();
  }, [page, perPage]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePerRowsChange = (newPerPage, newPage) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  // approval
  const handleExpenseApprova = async (data) => {
    const { id: expenseId, amount, branch_info } = data;
    const myaction = "approve";
    const cleanAmount = parseFloat(amount.replace(/,/g, ''));

    const { isConfirmed } = await Swal.fire({
      title: "Approve Expense",
      html: `
        <input type="text" value="${branch_info.name}" 
          class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
        <input type="text" value="₦${cleanAmount.toLocaleString()}"
          class="w-full px-4 py-2 border border-gray-300x rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
        <input type="hidden" value="${myaction}"
          class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
      `,
      showCancelButton: true,
      confirmButtonText: "Approve Expense",
      customClass: {
        confirmButton: "bg-dash text-white hover:bg-dash focus:ring-2 focus:ring-dash", // red button
        title: "text-dash",
      },
    });

    if (isConfirmed) {
      try {
        setConfirmationLoading(true);
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) throw new Error("No access token found.");

        const payload = {
          expense_id: expenseId,
          action: myaction,
        };

        const response = await axios.post(ApiServices.ExpenseOpeApproval, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message } = response.data;
        if (status === 200) {
          toast.success(message, { toastId: "expense-approved-success" });
          await fetchAllExpenses();
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setConfirmationLoading(false);
      }
    }
  };
  // rejecetion
  const handleExpenseRejection = async (data) => {
    const { id: expenseId, amount, branch_info } = data;
    const myaction = "reject";
    const cleanAmount = parseFloat(amount.replace(/,/g, ''));

    const { value: formValues, isConfirmed } = await Swal.fire({
      title: "Reject Expense",
      html: `
        <input type="text" value="${branch_info.name}" 
          class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
        <input type="text" value="₦${cleanAmount.toLocaleString()}"
          class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
        <textarea id="reason" placeholder="Enter your reason for rejection"
          class="w-full px-4 py-2 border border-gray-300 rounded-md mb-1 resize-none h-24"></textarea>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Reject Expense",
      customClass: {
        confirmButton: "bg-dash3 text-white hover:bg-dash3 focus:ring-2 focus:ring-dash3", // red button
        title: "text-dash3",
      },
      preConfirm: () => {
        const reason = document.getElementById("reason").value.trim();

        if (!reason) {
          Swal.showValidationMessage("Reason for rejection is required");
          return;
        }

        return { reason };
      },
    });

    if (isConfirmed && formValues) {
      try {
        setConfirmationLoading(true);
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) throw new Error("No access token found.");

        const payload = {
          expense_id: expenseId,
          action: myaction,
          rejection_reason: formValues.reason,
        };

        const response = await axios.post(ApiServices.RejectExpenseOpe, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message } = response.data;
        if (status === 200) {
          toast.success(message, { toastId: "expense-rejected-success" });
          await fetchAllExpenses();
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setConfirmationLoading(false);
      }
    }
  };

  //make payment
  const handleExpensePay = async (data) => {
    const { id: expenseId, amount, branch_info } = data;
    const myaction = "pay";
    const cleanAmount = parseFloat(amount.replace(/,/g, ''));

    const { isConfirmed } = await Swal.fire({
      title: "Pay Expense",
      html: `
      you are about to pay ${data.category} fee of amount  ₦${cleanAmount.toLocaleString()} for ${branch_info.name}
      `,
      showCancelButton: true,
      confirmButtonText: "Make Payment",
      customClass: {
        confirmButton: "bg-dash5 text-white hover:bg-dash5 focus:ring-2 focus:ring-dash5", // red button
        title: "text-dash5",
      },
    });

    if (isConfirmed) {
      try {
        setConfirmationLoading(true);
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) throw new Error("No access token found.");

        const payload = {
          expense_id: expenseId,
          action: myaction,
        };

        const response = await axios.post(ApiServices.PaymentExpenseOpe, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message } = response.data;
        if (status === 200) {
          toast.success(message, { toastId: "expense-approved-success" });
          await fetchAllExpenses();
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setConfirmationLoading(false);
      }
    }
  };

  const handleChange = ({ selectedRows }) => {
    setSelectedData(selectedRows);
    // console.log("===========selected rows=========", selectedRows);
  };

  useEffect(() => {
    // console.log("Selected Rows usestate: ", selectedData);
  }, [selectedData]);

  // bulk approval
  const handleBulkApproval = async () => {
    if (!selectedData || selectedData.length === 0) return;

    const { isConfirmed } = await Swal.fire({
      title: "<span style='color:#1D9E34'>Confirm Bulk Approval</span>",
      html: `
        <p>You are about to approve <strong>${selectedData.length}</strong> expenses.</p>
        <p>This action cannot be undone.</p>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve",
      customClass: {
        confirmButton: "bg-darkGreen3 text-white hover:bg-darkGreen3 focus:ring-2 focus:ring-darkGreen3",
        title: "text-dash5",
      },
      // cancelButtonText: "Cancel",
      // confirmButtonColor: "#15803d", 
      // cancelButtonColor: "#d1d5db",
    });

    if (isConfirmed) {
      try {
        setConfirmationLoading(true);
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) throw new Error("No access token found.");

        const payload = {
          expense_ids: selectedData.map((item) => item.id),
          action: "approve",
        };

        const response = await axios.post(ApiServices.ExpenseOpeBulkApproval, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message } = response.data;
        if (status === 200) {
          toast.success(message, { toastId: "bulk-approval-success" });
          setSelectedData([]);
          await fetchAllExpenses();
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setConfirmationLoading(false);
      }
    }
  };

  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  // Define Expandable Component for Actions
  const ExpandableComponent = ({ data }) => (
    <div className="flex justify-start p-4 relative">
      {permissions.some(permission => permission.name === 'branch.expense.view') && (
        <div className="mx-2 my-2 group relative">
          <Link
            to="/operations/branch/expenses/show"
            state={{ data }}
          >
            <Eye className="w-5 h-5 text-dash4 " />
          </Link>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block  text-darkGreen3 text-xs px-2 py-1 rounded">
            Details
          </div>
        </div>
      )}
      {permissions.some(permission => permission.name === 'branch.expense.approve') && data.status === "pending" && (
        <div className="mx-2 my-2 group relative">
          <button
            onClick={() => handleExpenseApprova(data)}
            disabled={confirmationLoading}
          >
            <CheckSquareFill className="w-5 h-5 text-darkGreen3" />
          </button>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash4 text-xs px-2 py-1 rounded">
            Approve
          </div>
        </div>
      )}

      {/* {
        permissions.some(permission => permission.name === 'branch.expense.approve') && data.status === "approved" && (
          <div className="mx-2 my-2 group relative">
            <button
              onClick={() => handleExpenseRejection(data)}
              disabled={confirmationLoading}
            >
              <XSquareFill className="w-5 h-5 text-dash3 " />
            </button>
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash text-xs px-2 py-1 rounded">
              Reject
            </div>
          </div>
        )
      } */}
      {/* {
        permissions.some(permission => permission.name === 'branch.expense.pay') && (
          <div className="mx-2 my-2 group relative">
            <button
              onClick={() => handleExpensePay(data)}
              disabled={confirmationLoading}
            >
              <CashStack className="w-5 h-5 text-dash5 " />
            </button>
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash5 text-xs px-2 py-1 rounded">
              Pay
            </div>
          </div>
        )
      } */}
    </div >
  );


  const columns = [
    {
      name: "Date",
      selector: (row) =>
        row.created_at ? new Date(row.created_at).toLocaleString() : "NOT AVAILABLE",
      sortable: true,
      width: "180px",
    },
    {
      name: "Reference",
      selector: (row) => (row.reference ? row.reference.toUpperCase() : "NOT AVAILABLE"),
      sortable: true,
      width: "200px",
    },
    {
      name: "Category",
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <span className="block font-bold">
            {row.category_name
              ? row.category_name.toUpperCase()
              : "NOT AVAILABLE"}
          </span>
          <span className="px-3 py-0.5 rounded-md bg-orange1 text-lGrey2 text-xs">
            {row.branch_info.name
              ? row.branch_info.name.toLowerCase()
              : "NOT AVAILABLE"}
          </span>
        </div>
      ),
    },
    {
      name: "Amount",
      selector: (row) => CurrencyFormatter(row.amount ? row.amount : "0.00"),
      sortable: true,
      width: "200px",
    },

    // {
    //   name: "Status",
    //   selector: (row) =>
    //     row.status ? row.status.toUpperCase() : "NOT AVAILABLE",
    //   sortable: true,
    //   cell: (row) => {
    //     const status = row.status?.toLowerCase();
    //     let statusClass = "";

    //     if (status === "pending") {
    //       statusClass = "text-orange1";
    //     } else if (status === "approved") {
    //       statusClass = "text-dash";
    //     } else if (status === "rejected") {
    //       statusClass = "text-dash3";
    //     } else {
    //       statusClass = "text-dash5";
    //     }

    //     return (
    //       <span className={statusClass}>
    //         {row.status ? row.status.toUpperCase() : "NOT AVAILABLE"}
    //       </span>
    //     );
    //   },
    //   width: "100px",
    // },

    {
      name: "Description",
      selector: (row) => row.description ? row.description : "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
  ];

  const filteredItems = expense.filter((item) =>
    Object.keys(item).some((key) =>
      item[key]?.toString().toLowerCase().includes(filterText.toLowerCase())
    )
  );


  const data = filteredItems.map((expense) => ({
    reference: expense.reference || "NOT AVAILABLE",
    category_name: expense.category_name,
    amount: expense.amount || "NOT AVAILABLE",
    base_price: expense.description,
    status: expense.status,
    created_at: expense.created_at,
    description: expense.description,
    branch_info: expense.branch_info,
    id: expense.id,
  }));

  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  });


  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
            <nav className="bg-gray-200 py-0 px-4 rounded-lg">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Operations
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Expenses
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1">List</p>
                </li>
              </ol>
            </nav>
          </section>
          <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between items-center">
            <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
              <input
                type="search"
                className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                placeholder="Search"
                value={filterText}
                onChange={handleFilter}
              />
            </div>

            <div className="flex space-x-2 sm:space-x-3 mt-2 sm:mt-0">
              {permissions.some(permission => permission.name === 'branch.expense.approve') &&
                selectedData &&
                selectedData.length > 0 && (
                  <button
                    onClick={handleBulkApproval}
                    className="text-dGrey3 bg-dash5 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                  >
                    <span className="flex items-center">
                      <CheckSquareFill className="mr-2" />
                      Bulk Approval
                    </span>
                  </button>

                )}

            </div>
          </div>

          {loading ? (
            <Spinner />
          ) : (
            <DataTable
              keyField="id"
              columns={columns}
              data={sortedData}
              progressPending={loading}
              pagination
              paginationServer
              paginationRowsPerPageOptions={[20]}
              paginationTotalRows={total}
              paginationDefaultPage={page}
              paginationPerPage={perPage}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              highlightOnHover
              striped
              customStyles={CustomStyles}
              noDataComponent={<div>No Expenses found</div>}
              expandableRows
              expandableRowsComponent={ExpandableComponent}
              selectableRows
              onSelectedRowsChange={handleChange}
            />
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default ExpensesList;






